import { OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { Box, Grid, ListItem, ListItemIcon, ListItemText, Typography } from '@alice-financial/pretext-ui'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import * as React from 'react'
// import { CompanyRepresentativeForm } from '../../companyProfile/CompanyRepresentativeForm'
import { OrganizationDetailsForm } from './OrganizationDetailsForm'
import { KYCButton } from './KYCButton'
import { hasAllOrgData, hasFinancialInformation } from './kycUtils'

const CompanyRepresentativeSuccess = ({
  companyRepresentative,
}: {
  companyRepresentative: NonNullable<
    OrganizationDetailFragment['aliceCardProgram']['companyAccount']
  >['companyRepresentative']
}) => (
  <ListItem>
    <ListItemIcon sx={{ alignSelf: 'center' }}>
      <CheckCircleIcon fontSize="large" color="primary" />
    </ListItemIcon>
    <ListItemText
      primary="Company Representative assigned"
      secondary={`${companyRepresentative?.firstName} ${companyRepresentative?.lastName} (${companyRepresentative?.email})`}
    />
  </ListItem>
)

export const CompanyRepresentativeComponent = ({ org }: { org: OrganizationDetailFragment }) => {
  const orgDataComplete = hasAllOrgData(org) && hasFinancialInformation(org)
  const hasCompanyRepresentative = Boolean(org.aliceCardProgram?.companyAccount?.companyRepresentative)

  // Check for pending verification requirements
  const requirementsPendingVerification =
    org.aliceCardProgram?.companyAccount?.requirementsPendingVerification || []
  const hasRequirementsPendingVerification = requirementsPendingVerification.length > 0

  // Check for currently due requirements (ignoring external_account)
  const currentlyDueRequirements = org.aliceCardProgram?.companyAccount?.currentlyDueRequirements || []
  // the `external_account` requirement is satisfied by the PBA/banking connection - do not consider it for this interface
  const hasCurrentlyDueRequirements =
    currentlyDueRequirements.filter((req) => req !== 'external_account').length > 0

  // Show KYC button when all data is complete, verification is done, but verification failed
  const shouldShowKycButton =
    orgDataComplete &&
    hasCompanyRepresentative &&
    !hasRequirementsPendingVerification &&
    hasCurrentlyDueRequirements

  const companyRepresentative = org.aliceCardProgram?.companyAccount?.companyRepresentative
  if (orgDataComplete && companyRepresentative && !shouldShowKycButton) {
    return <CompanyRepresentativeSuccess companyRepresentative={companyRepresentative} />
  }

  return (
    <>
      <Grid container flexDirection="column">
        {/* Group 1: Organization Details */}
        <Grid container flexWrap="nowrap" borderBottom={1} borderColor="divider" py={2} columnSpacing={2}>
          <Grid>
            <OrganizationDetailsForm org={org} />
          </Grid>
        </Grid>

        {/* Group 3: Company Representative */}
        {/* <Grid container flexWrap="nowrap" py={2} columnSpacing={2}>
          <Typography variant="h1" component="p" fontSize="3.5rem" fontWeight="bolder">
            2
          </Typography>
          <Grid>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Designate the person authorized to represent the company for financial services compliance.
            </Typography>
            <CompanyRepresentativeForm org={org} />
          </Grid>
        </Grid> */}

        {shouldShowKycButton && (
          <Box py={2}>
            <Typography variant="body2" gutterBottom>
              <strong>Some information is missing or failed verification.</strong>
            </Typography>
            <Typography variant="body2" gutterBottom>
              Click the button below to transfer to Stripe, our financial services partner, in order to
              provide the missing information.
            </Typography>
            <KYCButton org={org} size="large" />
          </Box>
        )}
      </Grid>
    </>
  )
}

export const CompanyRepresentativeInstructions = () => (
  <>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      This step is required for financial services compliance for the Contributions Account that holds your
      employees&apos; benefit contributions.
    </Typography>
    <Typography variant="body2" gutterBottom>
      You will only need to complete this step once.
    </Typography>
  </>
)
